<template>
  <div class="h-100">
    <div class="card">
      <div class="card-body p-0">
        <div class="row w-100 m-0">
          <div class="col-12 tenders-list p-0">
            <tender-info-block v-if="tenderData" :tender="tenderData" :withoutActions="true"/>
            <div class="d-flex flex-wrap gap-2 padding-r-10 padding-l-10 padding-t-20 padding-b-20 flex-wrap">
              <div class="divider"/>
              <p class="col-12 last-offers-text font-weight-bold p-0">Առաջին 5 տեղերը զբաղեցրած գները</p>
              <div class="tender-offers-table-block col-12 col-xl-7 p-0 d-flex padding-b-10 padding-r-20">
                <div v-if="(tenderData.lastOffers && tenderData.lastOffers.length)" class="table-responsive little-scroll">
                  <v-client-table class="table-border-radius" :columns="columns" v-model="lastOfferData" :options="options">
                    <div slot="input" class="d-flex justify-content-start align-items-center h-100" slot-scope="{row}">
                      <input @click="(e) => {e.stopPropagation()}" type="radio" name="offer" class="select-offer-radio" @change="() => handleSelectOffer(row)"/>
                    </div>
                    <div slot="price" class="d-flex justify-content-start align-items-center h-100" slot-scope="{row}">
                      <span :class="me.vat_payer_type === 'payer' && 'font-weight-bold text-primary'">{{ roundTwoDigits(row.price)}}</span>
                    </div>
                    <div slot="vat" class="d-flex justify-content-start align-items-center h-100" slot-scope="{row}">
                      <span>{{ roundTwoDigits(row.total_price - row.price) }}</span>
                    </div>
                    <div slot="total_price" class="d-flex justify-content-start align-items-center h-100" slot-scope="{row}">
                      <span :class="me.vat_payer_type !== 'payer' && 'font-weight-bold text-primary'">{{ roundTwoDigits(row.total_price) }}</span>
                      <div v-if="row?.price_interval?.length" @click="openPriceIntervalModal(row.price_interval)" v-tooltip="'Սահմանված շեմեր'" class="text-primary p-2 pointer">
                        <i class="fa-solid fa-square-up-right"></i>
                      </div>
                    </div>
                  </v-client-table>
                </div>
                <div v-else>
                  <p class="col-12 font-weight-bold text-secondary p-0">Ներկայացված գներ առկա չեն</p>
                </div>
              </div>
              <div class="tender-order-block col-12 col-xl-5 ">
                <div class="tender-offer-header">
                  <span>Պատվիրել</span>
                </div>
                <div class="form-group w-100 padding-l-20 padding-r-20 padding-t-20 d-flex align-items-center tender-input-group tender-input-group-center">
                  <div class="d-flex p-0 col-auto">
                    <p class="mr-2">
                      Քանակ՝
                    </p>
                  </div>
                  <input
                      v-model.number="order.count"
                      @change="handleChangeCount"
                      v-positive-only.none-zero
                      placeholder="Քանակ"
                      type="text"
                      name="unit"
                      class="tender-input col-4 m-0"
                  />
                </div>
                <div class="form-group w-100 padding-l-20 padding-r-20 padding-t-20 d-flex align-items-center tender-input-group tender-input-group-center">
                  <div class="d-flex p-0 col-auto">
                    <p class="mr-2">
                      Մատակարարման հասցե՝
                    </p>
                  </div>
                  <input
                      v-model="order.delivery_address"
                      placeholder="Մատակարարման հասցե"
                      type="text"
                      name="delivery_address"
                      class="tender-input col m-0"
                  />
                </div>
                <div class="form-group w-100 padding-l-20 padding-r-20 padding-t-20 d-flex flex-wrap align-items-center tender-input-group tender-input-group-center">
                  <div class="d-flex flex-wrap p-0 col-12">
                    <div class="col-auto p-0 d-flex align-items-center">
                      <p class="mr-2">
                        Ընդհանուր գումարը (դր)՝
                      </p>
                    </div>
                    <div class="col-auto col-xl-6 p-0">
                      <input
                          v-model.number="totalAmount"
                          v-positive-only.none-zero
                          disabled
                          style="color: #006BE6; font-weight: 600"
                          type="number"
                          class="tender-input w-100 m-0"
                      >
                    </div>
                  </div>
                </div>
                <div v-if="countGreaterThenOffer" class="form-group w-100 padding-l-20 m-0 padding-r-20 d-flex align-items-center tender-input-group tender-input-group-center">
                  <span class="m-0 helper-text text-danger font-weight-bold">Նշված քանակը գերազանցում է մասնակցի կողմից նշված քանակը` {{selectedOffer.count}}</span>
                </div>
                <div v-if="countLowerThenMinCount" class="form-group w-100 padding-l-20 m-0 padding-r-20 d-flex align-items-center tender-input-group tender-input-group-center">
                  <span class="m-0 helper-text text-danger font-weight-bold">Սահմանված է պատվերի նվազագույն քանակ, մասնակցի կողմից նշված նվազագույն քանակը` {{selectedOffer.min_count}}</span>
                </div>
                <div class="form-group justify-content-end w-100 padding-l-20 padding-r-20 padding-t-20 d-flex align-items-center tender-input-group tender-input-group-center">
                  <div class="h-100" v-tooltip="contractHtml && 'Պահմանագրի նախագիծը հաստատված է'">
                    <button @click="handleOpenContract" :disabled="contractHtml !== ''" :class="contractHtml ? 'btn-primary' : 'btn-outline-primary'" class="btn հ-100 mr-2">
                      <span>Պայմանագրի նախագիծ</span>
                    </button>
                  </div>
                  <div class="h-100" v-tooltip="(!downloadedContract) && 'Բեռնեք պայմանագրի նախագիծը'">
                    <button @click="triggerFileInput" :disabled="!downloadedContract" class="m-0 btn h-100 mr-2" :class="(signedContract) ? 'btn-primary' : 'btn-outline-primary'">
                      <span>Կցել ID-ով ստոր․ պայմանագիր</span>
                      <input ref="fileInput" @change="uploadSignedContract" type="file" accept=".pdf,.doc,.docx" hidden>
                    </button>
                  </div>
                  <div class="h-100" v-tooltip="(!contractHtml && !signedContract) && 'Հաստատեք պայմանգրի նախագիծը գնումը հաստատելու համար'">
                    <button @click="sendOrder" style="height: 100%;" :disabled="!contractHtml && !signedContract" class="btn btn-primary հ-100">
                      <span>Գնել</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <timeless-confirm-modal/>
    <timeless-interval-modal/>
    <new-editor-modal :openedBy="'buyer'" :tender="contractData" @handleGetContract="handleGetContract" @handleDownloadContract="handleDownloadContract"/>
  </div>
</template>
<script>
  import isMobile from '@/mixins/isMobileView'
  import TenderInfoBlock from '@/components/timelessTenders/TenderInfoBlock.vue'
  import TimelessConfirmModal from '@/components/helpers/TimelessConfirmModal.vue'
  import { required } from 'vuelidate/lib/validators'
  import NewEditorModal from '@/views/fileManagment/timeless/NewEditorModal.vue'
  import TimelessIntervalModal from '@/components/helpers/TimelessIntervalModal.vue'

  export default {
    components: { TimelessIntervalModal, NewEditorModal, TenderInfoBlock, TimelessConfirmModal },
    mixins: [isMobile],
    data() {
      return {
        dateNow: new Date(),
        backendUrl: process.env.VUE_APP_URL,
        elSign: '',
        downloadedContract: false,
        signedContract: '',
        signedContractFile: '',
        contractData: {
          totalAmount: 0,
          isWithVat: 0,
          rows: [
            {
              name: 'name',
              specification: 'specification',
              unit: 'unit',
              count: 'count',
              terms_of_purchase: 'terms_of_purchase',
              delivery_terms: 'delivery_terms',
              offer_delivery_terms: 'offer_delivery_terms',
              payment_terms: 'payment_terms',
              delivery_address: 'delivery_address',
            },
          ]
        },
        tenderData: false,
        countGreaterThenOffer: false,
        countLowerThenMinCount: false,
        contractHtml: '',
        contractSign: '',
        mainPicture: '',
        selectedOffer: {
        },
        totalAmount: '',
        order: {
          timeless_tender_id: this.$route.params.tenderId,
          count: 0,
          delivery_address: '',
        },
        lastOfferData: [],
        options: {
          sortable: [],
          perPage: 1000,
          perPageValues: [],
          columnsDropdown: false,
          filterByColumn: false,
          skin: 'table table-striped table-border-radius',
          dateFormat: "YYYY-mm-dd",
          headings: {
            mark: 'Ապրանքի անվանումը',
            input: '',
            price: 'Առանց ԱԱՀ գին',
            vat: 'ԱԱՀ',
            total_price: 'Ընդհանուր գումար',
            count: 'Քանակ',
            delivery_terms: 'Առաքման պայմանները',
          },
          filterable: false
        },
        columns: [
          'mark',
          'input',
          'price',
          'vat',
          'total_price',
          'count',
          'delivery_terms'
        ],
      }
    },
    computed: {
      currentPlan() {
        return this.$store.getters['procurement/currentPlan']
      },
      locale() {
        return this.$store.getters['user/locale']
      },
      me() {
        return this.$store.getters['user/me']
      },
    },
    mounted() {
      if(this.$route.params.tenderId){
        console.log('HERE SENDING ', this.$route.params.tenderId)
        this.$client.get(`timeless-tenders/${this.$route.params.tenderId}`).then(({ data }) => {
          console.log('data', data.data)
          this.tenderData = data.data;
          this.lastOfferData = data.data?.lastOffers;
          this.mainPicture = data.data.pictures[0];
        })
        this.$client.get(`timeless-tenders/lastDeliveryAddress/${this.$route.params.tenderId}`).then(({ data }) => {
          console.log('lastDeliveryAddress', data)
          // this.contractData.rows[0].delivery_address = data;
          this.order.delivery_address = data;
        })
      }
    },
    validations: {
      order: {
        count: {required},
        delivery_address: {required},
      }
    },
    methods: {
      openPriceIntervalModal(priceInterval){
        this.$modal.show('timeless-interval-modal', {
          priceIntervalArray: priceInterval,
        })
      },
      triggerFileInput() {
        // Trigger the hidden file input click
        this.$refs.fileInput.click();
      },
      async uploadSignedContract(event) {
        const file = event.target.files[0];
        this.contractHtmlFile = file;
        if (!file) {
          alert('Please select a file to upload.');
          return;
        }

        const formData = new FormData();
        formData.append('pdf_file', file);

        await this.$client.post('/check-signed-pdf', formData).then(({data}) => {
          if(data.isSigned){
            this.$notify({
              group: 'foo',
              type: 'success',
              text: 'Հաջողությամբ հաստատված է'
            })
            this.signedContract = true;
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              text: 'Ինչ որ բան այն չէ, Կրկին փորձեք!'
            })
            this.signedContract = false;
          }
        }).catch(() => {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Ինչ որ բան այն չէ, Կրկին փորձեք!'
          })
          this.signedContract = false;
        });
      },
      handleOpenContract(){
        if(!this.$v.$invalid && this.selectedOffer.id && !this.countGreaterThenOffer && !this.countLowerThenMinCount) {
          this.contractData.code = this.tenderData.code;
          this.contractData.totalAmount = this.totalAmount;
          this.contractData.isWithVat = this.selectedOffer.is_with_vat;
          this.contractData.rows[0] = {
            name: this.tenderData.name,
            specification: this.tenderData.specification,
            unit: this.tenderData.unit,
            count: this.order.count,
            terms_of_purchase: this.tenderData.terms_of_purchase,
            delivery_terms: this.tenderData.delivery_terms,
            offer_delivery_terms: this.selectedOffer.delivery_terms,
            payment_terms: this.tenderData.payment_terms,
            delivery_address: this.order.delivery_address,
          };

          this.$modal.show('new-editor-modal', {
            action: 'save',
            fileName: 'contract_draft',
            editorTitle: 'Պայմանագրի նախագիծ'
          })
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
          })
        }
      },
      handleDownloadContract(){
        console.log('handleDownloadContract')
        this.$modal.hide('new-editor-modal')
        this.downloadedContract = true;
      },
      async handleGetContract(contract, signedDocument){
        this.contractHtml = contract;
        this.contractSign = signedDocument;
        this.$modal.hide('new-editor-modal')
      },
      handleChangeCount() {
        const price = this.getMatchingPrice(this.selectedOffer, this.order.count);
        this.totalAmount = price * this.order.count;
        this.countGreaterThenOffer = +this.selectedOffer.count < this.order.count;
        this.countLowerThenMinCount = +this.selectedOffer.min_count > this.order.count;
      },
      handleSelectOffer(offer) {
        this.order.count = offer.min_count;
        this.selectedOffer = offer;
        const price = this.getMatchingPrice(offer, this.order.count);
        console.log('Selected Price:', price);
        this.totalAmount = price * this.order.count;
        this.countGreaterThenOffer = offer.count < this.order.count;
        this.countLowerThenMinCount = offer.min_count > this.order.count;
      },
      getMatchingPrice(offer, count) {
        if (offer.price_interval && Array.isArray(offer.price_interval)) {
          // Find the correct interval where count falls between min_count and max_count
          const interval = offer.price_interval.find(interval =>
              count >= interval.min_count && count <= interval.max_count
          );

          if (interval) {
            return this.me.vat_payer_type !== 'payer' ? +interval.total_price : +interval.price;
          }
        }

        // Default to offer's price if no interval matches

      // return this.me.vat_payer_type !== 'payer' ? +offer.total_price : +offer.price;
      return offer.total_price;

      },
      roundTwoDigits(number) {
        return Math.round(number * 100) / 100
      },
      sendOrder(){
        if(!this.$v.$invalid && this.selectedOffer.id && !this.countGreaterThenOffer && !this.countLowerThenMinCount && (this.contractHtml || this.signedContract)) {
          this.$modal.show('timeless-confirm-modal', {
            msg: 'tender',
            callback: async () => {
              this.order.timeless_offer_id = this.selectedOffer.id;
              this.order.contract = this.contractHtml;
              this.order.sign = this.contractSign;
              console.log(this.contractHtmlFile)
              if(this.contractHtmlFile){
                this.order.signed_contract = this.contractHtmlFile;
              }
              const formData = new FormData();
              Object.keys(this.order).forEach((key) => {
                formData.append(key, this.order[key]);
              });
              this.$client.post('timeless-tenders/sendOrder', formData).then(({data}) => {
                if(data){
                  this.$notify({
                    group: 'foo',
                    type: 'success',
                    text: 'Հաջողությամբ հաստատված է'
                  })
                  this.$modal.hide('timeless-confirm-modal');
                  this.$router.push('/timeless-tenders/buy/orders')
                }
              }).catch(() => {
                this.$notify({
                  group: 'foo',
                  type: 'error',
                  text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
                })
              })
            }
          })
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
          })
        }
      },
      deleteTender(id){
        this.$client.delete(`timeless-tenders/${id}`).then(({data}) => {
          this.$client.get('manager/timeless-tenders').then(({data}) => {
            console.log('data', data.data)
            this.tenders = data.data;
          })
        })
      }
    },
  }
</script>
<style scoped>
.tender-order-block{
  padding: 0px !important;
  display: flex !important;
  flex-wrap: wrap;
  border: 1px solid #EDEFF2;
  border-radius: 12px;


  .send-offer-btn[disabled]{
    background: #EDEFF2 !important;
    border: none !important;
    span{
      color: #6E7485;
    }
  }

  .send-offer-btn{
    height: 48px;
    border-radius: 8px;

    span{
      font-size: 16px !important;
      font-weight: 500;
    }
  }

  .tender-offer-header{
    width: 100%;
    height: 56px;
    background: #EDEFF2;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 16px 20px;

    span{
      font-size: 16px;
      font-weight: 600;
    }
  }
}
@media (max-width: 1200px) {
  .tender-offers-table-block{
    padding: 0 0 20px 0 !important;
  }
  .tender-order-block{
    padding: 0 !important;
  }
}
.select-offer-radio{
  transform: scale(1.5);
}
.divider{
  margin: 6px 0 16px;
}
.last-offers-text{
  font-size: 18px;
  margin-bottom: 16px;
}

</style>
<style>
.tender-offers-table-block{
  .table-striped tbody .VueTables__row:nth-of-type(even){
    background-color: white !important;
  }
}
</style>
